// services/DiaperService.ts
import axiosInstance from './axiosInstance';
import { CareHomeDiaper } from '../interfaces/Diaper/IDiaper.ts';

class DiaperService {
  private static instance: DiaperService;
  private constructor() {}

  public static getInstance(): DiaperService {
    if (!DiaperService.instance) {
      DiaperService.instance = new DiaperService();
    }
    return DiaperService.instance;
  }

  public async getDiapers(params?: {
    page?: number;
    per_page?: number;
    query?: string;
    ignore_case?: boolean;
    orderBy?: string;
    sortOrder?: 'asc' | 'desc' | null;
    carehome_id?: string;
    category?: 'Front' | 'Back' | 'Panty' | null;
    is_active?: boolean;
  }): Promise<{
    items: CareHomeDiaper[];
    limit: number;
    offset: number;
    total: number;
  }> {
    try {
      const response = await axiosInstance.get<{
        items: CareHomeDiaper[];
        limit: number;
        offset: number;
        total: number;
      }>('/carehome_diapers', { params });
      return response.data;
    } catch (error: any) {
      throw new Error(
        `Failed to fetch diapers: ${error.response?.status || 'Unknown error'}`
      );
    }
  }

  public async getDiapersStat(params: {
    carehome_id: string;
    start_date: string;
    end_date: string;
    resident_ids?: string[];
    station_ids?: string[];
  }): Promise<number> {
    try {
      // Axios sends arrays in the format resident_ids[]=x&resident_ids[]=y by default
      // We convert each array to a string to send them in the format resident_ids=x,y
      const requestParams = {
        ...params,
        resident_ids: params.resident_ids?.join(','),
        station_ids: params.station_ids?.join(','),
      };

      const response = await axiosInstance.get<number>(
        '/analyse/diapers_stat',
        { params: requestParams }
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch diapers statistics');
    }
  }

  public async updateDiaperUsageAmount(
    residentId: string,
    diaperId: string,
    usageAmount: number
  ): Promise<void> {
    try {
      await axiosInstance.patch(
        `/residents/${residentId}/diapers/${diaperId}/usage_amount`,
        { usage_amount: usageAmount }
      );
    } catch (error) {
      throw new Error('Failed to update diaper usage amount');
    }
  }
}

export default DiaperService.getInstance();
